// src/components/Dashboard/Dashboard.tsx
import React from 'react';
import { Layout } from '../Layout';
import { DailyOverview } from './DailyOverview';
import { QuickAdd } from './QuickAdd'; 
import { UpcomingEventsCard } from './UpcomingEventsCard';
import { RecentActivity } from './RecentActivity';
import { MoodProvider } from '../../contexts/MoodContext';
import { useAuthContext } from '../../contexts/AuthContext';
import { useTaskContext } from '../../contexts/TaskContext';
import { Plus, X } from 'lucide-react';
import type { Role, Task } from '../../types';

export function Dashboard() {
  const { user } = useAuthContext();
  const [showAddTask, setShowAddTask] = React.useState(false);
  const [editingTask, setEditingTask] = React.useState<Task | null>(null);
  const { tasks, addTask, updateTask, deleteTask } = useTaskContext();
  const [activeRole, setActiveRole] = React.useState<Role>('all');
  const { roles } = useTaskContext();

  const handleEditTask = (task: Task) => {
    setEditingTask(task);
    setShowAddTask(true);
  };

  return (
    <MoodProvider>
      <Layout>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 lg:mb-0">
          <div className="lg:col-span-8 space-y-6">
            <div className="flex justify-between items-start pr-4">
              <DailyOverview userName={user?.user_metadata?.name || 'User'} />
            </div>
            <RecentActivity 
              onAddTask={() => setShowAddTask(true)}
              onEditTask={handleEditTask}
              tasks={tasks.filter(task => !task.archived && (activeRole === 'all' || task.role === activeRole))}
            />
          </div>
          <div className="hidden lg:block lg:col-span-4 space-y-6">
            <UpcomingEventsCard />
          </div>
        </div>
      
        {showAddTask && (
          <QuickAdd
            initialTask={editingTask}
            onAdd={(task) => {
              if (editingTask) {
                updateTask(editingTask.id, task);
              } else {
                addTask(task);
              }
              setShowAddTask(false);
              setEditingTask(null);
            }}
            onDelete={async (taskId) => {
              try {
                await deleteTask(taskId);
                setShowAddTask(false);
                setEditingTask(null);
              } catch (err) {
                console.error('Error deleting task:', err);
              }
            }}
            onClose={() => {
              setShowAddTask(false);
              setEditingTask(null);
            }}
          />
        )}
      </Layout>
    </MoodProvider>
  );
}